import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignature } from '@fortawesome/free-solid-svg-icons';
import Bjudain from './Inputs/Bjudain'
import ConfirmBjuda from './Inputs/ConfirmBjuda'
import EmailInput from './Inputs/EmailInput'
import TeleInput from './Inputs/TeleInput'
import PersonNrInput from './Inputs/PersonNrInput'
import BehorigattvisaInput from './Inputs/BehorigattvisaInput'
import BehorigattSkrivaInput from './Inputs/BehorigattSkrivaInput'
import LangInput from './Inputs/LangInput'
import DaedLinePaminelseInput from './Inputs/DaedLinePaminelseInput'
import SkickaPaminelseInput from './Inputs/SkickaPaminelseInput'
import InvitationMess from './Inputs/InvitationMess'
import Divider from "@material-ui/core/Divider";
import {isEmpty} from 'lodash'

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));


function Esignering(props) {
    const classes = useStyles();
    return (
        <div>
           
            <div className={classes.root}>
                <div style={{ height: '64px', paddingTop: '15px' }} className="row">
                    <div className="col-6"  style={{ height: '64px' }}>
                        <Bjudain
                        Value={props.Esignering.Bjudain}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                    <div className="col-6"  style={{ height: '64px' }}>
                        <ConfirmBjuda
                        Value={props.Esignering.Bekraftelse}
                        Value2={props.Esignering.Bjudain}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                </div>
                {
                  props.Esignering.Bjudain !== "mobile" ?
                        <div style={{ height: '64px', paddingTop: '15px' }} className="row">
                            <div className="col-12"  style={{ height: '64px' }}>
                                <EmailInput 
                                error={
                                    (props.Esignering.Bjudain === "email_mobile" ||
                                    props.Esignering.Bjudain === "email") &&
                                    isEmpty(props.Esignering.Email)
                                }
                                Value={props.Esignering.Email}
                                onchangeHanelEvent={props.onchangeHanelEsignering}
                                />
                            </div>
                        </div>
                  :""
                }
                {
                    props.Esignering.Bjudain !== "email" ?
                    <div style={{ height: 'auto', paddingTop: '15px' }} className="row">
                        <div className="col-6"  style={{ height: 'auto' }}>
                            <TeleInput 
                             error={
                                (props.Esignering.Bjudain === "email_mobile" ||
                                props.Esignering.Bjudain === "mobile") &&
                                props.Esignering.Tele.length === 0
                            }
                                Value={props.Esignering.Tele}
                                onchangeHanelEvent={props.onchangeHanelEsignering}
                                />
                        </div>
                        <div className="col-6"  style={{ height: 'auto' }}>
                            <PersonNrInput 
                            error={
                                (
                                    props.Esignering.Behorigattvisa === "se_bankid" || props.Esignering.BehorigattSkriva === "se_bankid" ||
                                    props.Esignering.Behorigattvisa === "no_bankid" || props.Esignering.BehorigattSkriva === "no_bankid"
                                ) &&
                                props.Esignering.Tele.length === 0
                            }
                                PersonalNr={props.Esignering.PersonalNr}
                                onchangeHanelEvent={props.onchangeHanelEsignering}
                                />
                        </div>
                    </div>
                    :
                    <div style={{ height: 'auto', paddingTop: '15px' }} className="row">
                        <div className="col-12"  style={{ height: 'auto' }}>
                            <PersonNrInput 
                             error={
                                (
                                    props.Esignering.Behorigattvisa === "se_bankid" || props.Esignering.BehorigattSkriva === "se_bankid" ||
                                    props.Esignering.Behorigattvisa === "no_bankid" || props.Esignering.BehorigattSkriva === "no_bankid"
                                ) &&
                                props.Esignering.Tele.length === 0
                            }
                            PersonalNr={props.Esignering.PersonalNr}
                                onchangeHanelEvent={props.onchangeHanelEsignering}
                                />
                        </div>
                    </div>
                }
                
                <div style={{ height: '64px', paddingTop: '15px' }} className="row">
                    <div className="col-6"  style={{ height: '64px' }}>
                        <BehorigattvisaInput
                        Value={props.Esignering.Behorigattvisa}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                    <div className="col-6"  style={{ height: '64px' }}>
                        <BehorigattSkrivaInput
                        Value={props.Esignering.BehorigattSkriva}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                    
                </div>
                {
                    (
                        props.Esignering.Behorigattvisa === "se_bankid" || props.Esignering.BehorigattSkriva === "se_bankid" ||
                        props.Esignering.Behorigattvisa === "no_bankid" || props.Esignering.BehorigattSkriva === "no_bankid"
                    )?
                    <div style={{ height: '64px', paddingTop: '15px' }} className="row">
                    <div className="col-4"  style={{ height: '64px' }}>
                        <DaedLinePaminelseInput
                        Value={props.Esignering.DaedLinePaminelse}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                    <div className="col-4"  style={{ height: '64px' }}>
                        <SkickaPaminelseInput
                        Value={props.Esignering.SkickaPaminelse}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />                    
                    </div>
                    <div className="col-4"  style={{ height: 'auto' }}>
                        <LangInput
                        Value={props.Esignering.Lang}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                    </div>                    
                    :
                    <div style={{ height: '64px', paddingTop: '15px' }} className="row">
                    <div className="col-6"  style={{ height: '64px' }}>
                        <SkickaPaminelseInput
                        Value={props.Esignering.SkickaPaminelse}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />   
                    </div>
                    <div className="col-6"  style={{ height: 'auto' }}>
                        <LangInput
                        Value={props.Esignering.Lang}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                    </div> 
                }
                <div style={{ height: 'auto', paddingTop: '5px' }} className="row">
                    <div className="col-12"  style={{ height: 'auto' }}>
                        <InvitationMess
                        Value={props.Esignering.InvitationMessage}
                        onchangeHanelEvent={props.onchangeHanelEsignering}
                        />
                    </div>
                </div>
               <div style={{ paddingTop: '15px', paddingBottom: '10px' }}>
                <Divider />
                </div>

            </div>
        </div>
    );
}

export default Esignering;